/**
 * Contains autofill api calls.
 * @module api/autofill
 */
import DataEngine from '../../public/js/de';
import Settings from '../settings';
import FetchUtils from '../util/fetchUtils';
import { parseAutofillData } from '../util/autofillUtils';

const serverPath = Settings.serverPath;

const host = window.location.hostname;
const bucket = 'bn.camio.datalists';
const dataEngine = window.location.protocol === 'https:' ?
  new DataEngine({ host, path: 'dataengine/', bucket }) :
  new DataEngine({ host, port: 4300, bucket });

/**
 * Retrieves autofill data from camio.
 * @func getAutofillData
 * @param {string} name Replaceable name
 * @param {string} path Replaceable path
 * @return {Promise<Object[]|Error>}
 */
export const getAutofillData = (dataListName, dataListPath, replaceableName) => fetch(`${serverPath}AutofillHandler.ashx`, {
  method: 'post',
  mode: 'cors',
  body: FetchUtils.createFormData({
    dataListName,
    dataListPath
  }),
  cache: 'no-cache',
  credentials: 'include',
  dataType: 'json'
}).then(response => {
  if (response.ok) {
    return response.json();
  }
  throw (new Error('Response not ok.'));
}).then(data => {
  if (data.statusCode === 500) {
    console.log(data);
    throw (new Error('Unexpected error getting autofill data from camio.  Bad JSON received.'));
  }
  return Promise.resolve(parseAutofillData(data.data, replaceableName));
}).catch(error => { throw (new Error(`getAutofillData failed: ${error}`)); });

/**
 * Retrieves autofill column data from camio.
 * @func getAutofillColumnData
 * @param {string} path Replaceable path
 * @return {Promise<Object[]|Error>}
 */
export const getAutofillColumnData = async (dataListPath) => {
  try {
    const autofillData = await dataEngine.read(dataListPath);

    return Promise.resolve(autofillData);
  } catch (error) {
    console.error(`getAutofillColumnData failed: ${error}`);
    return Promise.resolve(null);
  }
};

/**
 * Gets the autofill image
 * @func getAutofillMedia
 * @param  {string} contextId Id of the current context
 * @param  {string} subject   The autofill search value
 * @return {Promise<Object[]|Error>}
 */
export const getAutofillMedia = (contextId, subject, type) => fetch(`${serverPath}AssetSearchHandler.ashx?type=autofill`, {
  method: 'post',
  mode: 'cors',
  body: JSON.stringify({
    assetType: type,
    contextId,
    searchTerms: subject
  }),
  cache: 'no-cache',
  contentType: 'application/json',
  credentials: 'include',
  dataType: 'json'
}).then(response => {
  if (response.ok) {
    return response.json();
  }
  throw (new Error('Response not ok.'));
}).then(data => {
  if (data.statusCode === 500) {
    console.log(data);
    throw (new Error('Unexpected error getting autofill media data from camio.  Bad JSON received.'));
  }
  return Promise.resolve(data.assets[0] || {});
}).catch(error => { throw (new Error(`getAutofillMedia failed: ${error}`)); });



// WEBPACK FOOTER //
// ./app/api/autofill.js